import { Component, OnInit } from '@angular/core';
import { LoadingService } from '@wz-services';

@Component({
  selector: 'wz-reclamations',
  templateUrl: './reclamations.component.html',
  styleUrls: ['./reclamations.component.scss'],
  standalone: false,
})
export class ReclamationsComponent implements OnInit {
  loading: boolean = false;

  constructor(private loadingService: LoadingService) {}

  ngOnInit() {}

  ngAfterContentInit() {
    this.loadingService.loadingSubject.next(false);
  }
}
